import React, { useEffect, useState } from 'react'
import useImageRandomPath from '../../hooks/useImageRandomPath'
import { PageTemplateContainer } from './styles'

interface NotSignedInPageTemplateProps {
  sideContent?: React.ReactNode
  wideContentSection?: boolean
}

const NotSignedInPageTemplate: React.FC<React.PropsWithChildren<NotSignedInPageTemplateProps>> = ({
  children,
  sideContent,
  wideContentSection,
}) => {
  const [imagePath, setImagePath] = useState(null)
  useEffect(() => {
    const path = useImageRandomPath()
    setImagePath(path)
  }, [])

  return (
    <PageTemplateContainer>
      <main className={wideContentSection ? 'wide-content' : ''}>
        <div className="content">
          <img src="/assets/images/logos/tabia-full.svg" className="logo" alt="" />
          {children}
        </div>
      </main>
      <aside className="side-content hidden-on-tablet">
        {sideContent || <img className="side-image" src={imagePath} alt="sideimage" />}
      </aside>
    </PageTemplateContainer>
  )
}
export default NotSignedInPageTemplate
